import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import api from "assets/services/api";
import useAuth from "hooks/useAuth";

export default function ModalNfeReconciliation({ show, onHide }) {
  const { storageId } = useAuth();
  const [enterprises, setEnterprises] = useState([]);
  const [cnpj, setCnpj] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!show || !storageId) return;
    api
      .get(`/enterprise/${storageId}?pageSize=1000`)
      .then((res) => setEnterprises((res.data && res.data.enterprises) || []))
      .catch(() => setEnterprises([]));
  }, [show, storageId]);

  const canSubmit = cnpj && startDate && endDate && !loading;

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const start = Date.now();
      const { data } = await api.post('/nfe/reconciliation', { federalTaxNumber: cnpj, startDate, endDate });
      const jobId = data.jobId;

      const POLL = 5000;
      const TIMEOUT = 6 * 60 * 1000;
      // eslint-disable-next-line no-constant-condition
      while (true) {
        if (Date.now() - start > TIMEOUT) {
          throw new Error('Tempo excedido ao gerar o relatorio.');
        }
        await new Promise((r) => setTimeout(r, POLL));
        const st = await api.get(`/nfe/reconciliation/${jobId}/status`);
        if (st.data.status === 'done') break;
        if (st.data.status === 'error') throw new Error(st.data.error || 'Falha ao gerar o relatorio.');
      }

      const dl = await api.get(`/nfe/reconciliation/${jobId}/download`, { responseType: 'blob' });
      const blob = dl.data;
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = `conciliacao-${cnpj}-${startDate}_${endDate}.xlsx`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(link.href);
      if (onHide) onHide();
    } catch (err) {
      setError((err && err.message) || 'Falha ao gerar o relatorio. Tente novamente.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Conciliacao de NF de retorno</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit}>
          <label style={{ display: "block", marginBottom: "8px" }}>
            Empresa
            <select value={cnpj} onChange={(e) => setCnpj(e.target.value)} style={{ display: "block", width: "100%" }}>
              <option value="">Selecione a empresa</option>
              {enterprises.map((ent) => (
                <option key={ent.id} value={ent.cnpj}>
                  {ent.name}
                </option>
              ))}
            </select>
          </label>
          <label style={{ display: "block", marginBottom: "8px" }}>
            Data inicio
            <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} style={{ display: "block" }} />
          </label>
          <label style={{ display: "block", marginBottom: "8px" }}>
            Data fim
            <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} style={{ display: "block" }} />
          </label>
          <button type="submit" disabled={!canSubmit}>
            {loading ? "Gerando..." : "Gerar relatorio"}
          </button>
          {error && <p role="alert">{error}</p>}
        </form>
      </Modal.Body>
    </Modal>
  );
}
